import styled from 'styled-components';
import {ColumnFlexBox} from '@/styled-components';
import {palette} from '@/styles';
import Img01 from './assets/how-to-use01.png';
import Img02 from './assets/how-to-use02.png';
import Img03 from './assets/how-to-use03.png';
import Img04 from './assets/how-to-use04.png';
import {ScrollBody} from './StyledComponents';
import {AiSubHeader} from './SubHeader';

const HOW_TO_LIST = [
  {title: '상권 분석 버튼을 클릭해 주세요.', image: Img01},
  {title: '분석하고 싶은 지역을 선택해 주세요.', image: Img02},
  {title: '상권 분석 데이터를 확인해 보세요.', image: Img03},
  {title: 'AI 해설 창에서 해설 내용을 함께 읽어보세요.', image: Img04},
];

export const HowToUse = () => {
  return (
    <>
      <AiSubHeader />
      <ScrollBody>
        <Title>AI 기반 상권 분석 해설로 더 쉽게!</Title>
        <ColumnFlexBox gap={20}>
          <Desc>
            마이프차 지도 서비스에서 제공하는 상권 분석
            <br />
            데이터를 단순히 보는 것에서 끝내지 마세요.
            <br />
            상권 분석 AI 해설이 <strong>데이터의 의미를 해석</strong>
            하고 유용한 <strong>인사이트를 도출</strong>할 수 있도록 도와드려요.
          </Desc>
          <Desc>
            다만, 상권 분석 AI 해설은 AI 모델에 의해 다양한 데이터를 기반으로
            생성되고 있어서 부정확할 수 있어요. 정확한 정보가 전달될 수 있도록
            최선을 다하고 있으나 제공된 정보에 대한 이용 여부는 신중히 판단해
            주세요.
          </Desc>
        </ColumnFlexBox>
        <List>
          {HOW_TO_LIST.map((i, idx) => (
            <div key={i.title}>
              <ItemTitle>
                <ItemNumber>{idx + 1}</ItemNumber>
                {i.title}
              </ItemTitle>
              <ItemImage src={i.image} alt={`${i.title} 가이드 이미지`} />
            </div>
          ))}
        </List>
      </ScrollBody>
    </>
  );
};

const Title = styled.div`
  color: ${palette.black};
  font-size: 16px;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 16px;
  line-height: 1.5;
  padding-top: 4px;
`;

const Desc = styled.div`
  color: ${palette.grayBlack};
  font-size: 14px;
`;

const List = styled.div`
  padding-top: 60px;
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const ItemTitle = styled.div`
  color: ${palette.grayBlack};
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  letter-spacing: -0.42px;
`;

const ItemNumber = styled.div`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  border-radius: 100%;
  background-color: ${palette.black};
  color: ${palette.white};
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`;

const ItemImage = styled.img`
  width: 100%;
`;
